export default {
  infoTitle: 'University data information',
  infoDesc: 'You can check the application guidelines and application fee information',
  infoTypeApplicationFee: 'Application Fee Inquiry',
  infoTypeLanguageReq: 'Language Req Inquiry',
  schoolName: 'School Name',
  majorLevel: 'Course Level',
  keywordSearch: 'Keyword search',
  searchResultEmpty: 'Please modify search criteria.',
  search: 'Search',
  reset: 'Reset',
  dataTotalNumber: '{totalNumber} record(s)',
  country: 'Country',
  institutionName: 'Institution',
  serialNumber: 'No.',
  applicationFeeFound: 'Waive?',
  applicationFee: 'Application Fee',
  applicationFeeDetail: 'App fee remark',
  applicationLang: 'Language Type',
  applicationLangGoDetail: 'View language',
  operation: 'Operation',
  viewDetail: 'View Details',
  yes: 'Y',
  no: 'N',
  previous: 'Previous',
  next: 'Next',
  viewApplicationFee: 'View application fee',
  viewLanguageReq: 'View language type',
  professionalDetail: 'Professional content',
  matchCourseDetail: 'Eligible courses',
  courseDetailDataTotalNumber: 'Total {totalNumber} data',
  langTypeDesc: 'Description',
  langTypeOptionPlaceholder: 'Is there a language type'
}
